import { memo } from "react";
import { getExchangeIconUrl } from "../lib/exchangeIcons";

/**
 * Full-colour exchange logo rendered at a fixed small size (default 16 px)
 * next to an exchange name. Decorative (``alt=""``) since the name is always
 * shown as adjacent text. Returns null for DEX legs / logo-less exchanges so
 * the row simply shows text — no broken-image icon, no layout shift.
 */
export const ExchangeIcon = memo(function ExchangeIcon({
  exchange,
  size = 16,
  className = "",
}: {
  exchange: string | null | undefined;
  size?: number;
  className?: string;
}) {
  const url = getExchangeIconUrl(exchange);
  if (!url) return null;
  return (
    <img
      src={url}
      alt=""
      aria-hidden="true"
      loading="lazy"
      className={`inline-block shrink-0 rounded-sm object-contain ${className}`}
      style={{ width: size, height: size }}
    />
  );
});
